export default "__VITE_ASSET__zIn1FLtX__"